$shm_wordstat_dashboard $shm_service_dashboard
	dashboard_id \new
	user_id \
	administrating false
	tab_title \Wordstat
	task_mode \edit
	task_mode_view_enabled false
	task_title? \
	state null $shm_wordstat_filter_state_store
	filter_state null $shm_wordstat_filter_state_store
	log? \
	running? false
	job? null
	data null
	collect_items_table null
	collect_items_loaded false
	report_tools /
	period_all *
		from \0001-01-01
		to \2999-12-31
	period_all_kind* *
		from \0001-01-01
		to \2999-12-31
	pages <= dashboard_pages /
		<= Collect_page $shm_wordstat_filter_panel
			state <= state
			title_content /
				<= Dashboard_head
			tools /
			collecting true
			query_visible true
			query_limit <= query_limit 200
			queries_blur? <=> task_title_from_query? null
			period_kind_available /
			period_kind_visible true
			device_visible true
			region_available /
			region_visible true
			run_enabled <= run_enabled true
			run_title <= run_title \Собрать
			run_color <= run_color \
			run? <=> run? null
		<= Collects_page $mol_page
			title_content <= collects_title_content /
				<= Collects_title $mol_view
					attr *
						^
						title <= collects_title
					sub / <= collects_title \Сбор данных
				<= Collects_quota $mol_view
					attr *
						^
						title <= quota_title
					sub / <= quota_title \Лимит
				<= Collect_cancel $mol_button_minor
					title \Отменить сбор
					click? <=> cancel? null
			tools /
			body <= collects_body /
				<= Collect_regular_row $mol_view
					sub /
						<= Collect_regular $mol_check_box
							title \Ежедневно дособирать данные по дням
							checked? <=> regular_daily? false
						<= Collect_regular_hint $mol_view
							sub / \Сбор выполняется в 10:00 МСК
				<= Collect_items_table $shm_wordstat_table
					table <= collect_items_table null
				<= Reports_row $mol_view
					sub /
						<= Reports_actions $mol_view
							sub /
								<= Report_send $mol_button_minor
									title \Отправить отчет
									enabled <= report_send_enabled true
									click? <=> report_send? null
								<= Reports_enabled $mol_check_box
									title \Отправлять отчеты
									checked? <=> reports_enabled? false
						<= Telegram_chat_ids_label $mol_labeler
							title \ID чатов Telegram
							Content <= Telegram_chat_ids $mol_string
								hint \Через запятую
								value? <=> telegram_chat_ids_draft? \
								submit? <=> telegram_chat_ids_commit? null
								event *
									^
									blur? <=> telegram_chat_ids_commit? null
						<= Max_chat_ids_label $mol_labeler
							title \ID чатов MAX
							Content <= Max_chat_ids $mol_string
								hint \Через запятую
								value? <=> max_chat_ids_draft? \
								submit? <=> max_chat_ids_commit? null
								event *
									^
									blur? <=> max_chat_ids_commit? null
				<= Report_error $mol_text
					text <= report_error \
				<= Collect_empty $mol_text
					text <= collect_form_missing_message \
				<= Collect_error $mol_text
					text <= collect_error \
		<= Report_page $mol_page
			title <= dashboard_title \Wordstat
			title_content /
				<= Dashboard_head
			tools <= report_tools
			body /
				<= Result_panel $mol_view
					sub <= result_rows /
		<= Filters_page $shm_wordstat_filter_panel
			state <= filter_state
			period_all_kind* <= period_all_kind*
			collecting <= collecting true
			query_visible <= query_filter_visible true
			query_available <= query_available /
			period_kind_available <= period_kind_available /
			period_kind_visible <= period_kind_filter_visible true
			device_visible <= device_filter_visible true
			device_available <= device_available /
			region_available <= region_available /
			region_visible <= region_filter_visible true
			period_all <= period_all
			run_enabled <= run_enabled true
			run_title <= run_title \Собрать
			run_color <= run_color \
			run? <=> run? null
	Empty $mol_view
		sub /
			\Нет данных для выбранных фильтров
	Summary_table $shm_wordstat_table
		table <= query_summary null
	Data_table $shm_wordstat_table
		table <= query_table null
	Timeseries_chart $shm_wordstat_chart_timeseries
		rows <= chart_timeseries /
		period_kind <= period_kind \PERIOD_DAILY
		period_range_pick? <=> chart_period_range_pick? null
		rendered? <=> chart_rendered? null
	Settings $shm_service_task_menu
		remove? <=> task_delete? null
	Dashboard_head $shm_service_dashboard_head
		title? <=> task_title_draft? \
		title_save? <=> task_title_commit? null
		title_keydown? <=> task_title_keydown? null
		menu <= Settings
		edit? <=> task_mode_edit? null
		view? <=> task_mode_view? null
		view_visible <= task_mode_view_enabled
		view_enabled <= task_mode_view_enabled
		edit_color <= task_mode_edit_color \
		view_color <= task_mode_view_color \
	Csv_download $mol_button_download
		title \Скачать csv
		blob <= csv_blob null
		file_name <= csv_file_name \wordstat.csv
	Load_ready* $shm_wordstat_perf_ready
		task_id <= dashboard_id
		mode <= task_mode
		ready <= collect_items_loaded
